import {
  prefetchCustomerCompanyRetrieveQuery,
  prefetchCustomerPartialBusinessExtraDetailsRetrieveQuery,
  useCustomerBusinessAddressRetrieve,
  useCustomerBusinessExtraDetailsRetrieve,
  useCustomerPartialBusinessExtraDetailsRetrieve,
} from "@boundless/bl-api-client/customer/services"
import { createFileRoute, Navigate, redirect } from "@tanstack/react-router"

import { BusinessExtraDetailsForm } from "@/components/business-details/BusinessExtraDetailsForm"
import { PendingComponent } from "@/components/error/PendingComponent"

export const Route = createFileRoute("/_dashboard/company/extra-details")({
  component: RouteComponent,
  beforeLoad: ({ context: { store, hasPermissions } }) => {
    if (!hasPermissions(["customer.view_businessextradetails"])) {
      throw redirect({ to: "/" })
    }
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/company/details" })
    }
    return { companyUuid }
  },
  loader: async ({ context: { queryClient, companyUuid } }) => {
    prefetchCustomerCompanyRetrieveQuery(queryClient, companyUuid)
    prefetchCustomerPartialBusinessExtraDetailsRetrieveQuery(
      queryClient,
      companyUuid,
    )
  },
})

export function RouteComponent() {
  const { companyUuid } = Route.useRouteContext()

  const { data: businessAddress, isLoading: isAddressLoading } =
    useCustomerBusinessAddressRetrieve(companyUuid, {
      query: { refetchOnWindowFocus: false },
    })

  const { data: businessExtraDetails, isLoading: isExtraDetailsLoading } =
    useCustomerBusinessExtraDetailsRetrieve(companyUuid, {
      query: { refetchOnWindowFocus: false },
    })

  const {
    data: partialBusinessExtraDetails,
    isLoading: isPartialExtraDetailsLoading,
  } = useCustomerPartialBusinessExtraDetailsRetrieve(companyUuid, {
    query: { refetchOnWindowFocus: false },
  })

  const isLoading =
    isAddressLoading || isExtraDetailsLoading || isPartialExtraDetailsLoading

  if (isLoading) {
    return <PendingComponent />
  }

  // If no business address exists, redirect back to address step
  if (!businessAddress) {
    return <Navigate to="/company/address" />
  }

  return (
    <div className="@container">
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <BusinessExtraDetailsForm
            businessAddress={businessAddress}
            businessExtraDetails={businessExtraDetails}
            partialBusinessExtraDetails={partialBusinessExtraDetails}
            companyUuid={companyUuid}
          />
        </div>
      </div>
    </div>
  )
}
